module.exports = __webpack_public_path__ + "static/media/icon_paper_plane_def.9e023a4d.svg";